module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0